import { PAYMENT_STATUSES, type PaymentProvider, type PaymentStatus } from '@repo/api-contracts';

/** 결제 목록 상태 필터 — DEFAULT 는 READY 제외(서버 기본값), ALL 은 전체, 그 외는 그 상태 하나. */
export type PaymentStatusFilter = 'DEFAULT' | 'ALL' | PaymentStatus;

/** 필터 → 서버 입력. DEFAULT 는 입력에서 빼서 서버 기본값을 쓴다. */
export const statusesForFilter = (filter: PaymentStatusFilter): PaymentStatus[] | undefined => {
  if (filter === 'DEFAULT') {
    return undefined;
  }

  if (filter === 'ALL') {
    return [...PAYMENT_STATUSES];
  }

  return [filter];
};

export type PaymentProviderFilter = 'ALL' | PaymentProvider;
